/**
 * Tela de personalização do Chat de IA: preferências duráveis e prompts salvos.
 *
 * Duas abas porque são duas coisas diferentes (docs/PLANO_PERSONALIZACAO_IA.md):
 * a preferência entra sozinha em toda conversa; o prompt salvo só quando o
 * advogado clica nele. Chega por Configurações › IA.
 */
import { Sparkles } from 'lucide-react';

import { PreferenciasTab } from '@/components/ia-personalizacao/PreferenciasTab';
import { PromptsTab } from '@/components/ia-personalizacao/PromptsTab';
import { PageHeader } from '@/components/ui/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

function PersonalizacaoIaPage() {
  return (
    <div className="max-w-3xl space-y-6">
      <PageHeader
        icon={<Sparkles />}
        title="Personalização da IA"
        subtitle="Instruções que a IA sempre segue e pedidos que você reaproveita"
        backTo={{ label: 'Configurações', path: '/app/configuracoes' }}
      />

      <Tabs defaultValue="preferencias">
        <TabsList>
          <TabsTrigger value="preferencias">Preferências</TabsTrigger>
          <TabsTrigger value="prompts">Prompts salvos</TabsTrigger>
        </TabsList>
        <TabsContent value="preferencias" className="mt-4">
          <PreferenciasTab />
        </TabsContent>
        <TabsContent value="prompts" className="mt-4">
          <PromptsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default PersonalizacaoIaPage;
